import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule, NavigationEnd } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { TranslocoModule } from '@jsverse/transloco';
import { filter } from 'rxjs/operators';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { ToastComponent } from '../../components/shared/toast/toast.component';
import { SideMenuComponent } from '../../components/side-menu/side-menu.component';
import { LanguageRoutingService } from '../../services/language-routing.service';

@Component({
  selector: 'app-profile-layout',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    MatButtonModule,
    TranslocoModule,
    HeaderComponent,
    FooterComponent,
    ToastComponent,
    SideMenuComponent
  ],
  templateUrl: './profile-layout.component.html',
  styleUrls: ['./profile-layout.component.scss']
})
export class ProfileLayoutComponent {
  isMobileMenuOpen = false;

  // Routes the mobile dropdown can navigate to. Mirror of side-menu items so
  // the second-burger pattern can be replaced with a single <select>.
  readonly mobileNavRoutes = [
    { value: 'profile', labelKey: 'side-menu.profile' },
    { value: 'jobs', labelKey: 'side-menu.jobs' },
    { value: 'settings', labelKey: 'side-menu.settings' },
  ];

  currentMobileNav = 'profile';

  constructor(
    private readonly router: Router,
    private readonly languageRoutingService: LanguageRoutingService,
  ) {
    this.currentMobileNav = this.detectActiveRoute(this.router.url);
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => {
        this.currentMobileNav = this.detectActiveRoute(e.urlAfterRedirects);
      });
  }

  toggleMobileMenu(): void {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  closeMobileMenu(): void {
    this.isMobileMenuOpen = false;
  }

  onMobileNavChange(value: string): void {
    if (value === this.currentMobileNav) return;
    const lang = this.languageRoutingService.getCurrentLanguage();
    this.router.navigate([`/${lang}/${value}`]);
  }

  private detectActiveRoute(url: string): string {
    if (url.includes('/jobs')) return 'jobs';
    if (url.includes('/settings')) return 'settings';
    return 'profile';
  }
}
